export default __webpack_public_path__ + "static/media/Skirmisher's Mark of Abhorrence.2ca1a012.jpg";